export default __webpack_public_path__ + "static/media/tech-head.8e5529bc.jpg";